<template>
    <v-radio-group
        v-model="formValue"
        v-bind="orientation()"
        :label="label"
        :rules="rules"
        class="pt-0 mt-0"
        return-object
        @change="onSelectChange"
    >
        <v-row v-if="!$vuetify.breakpoint.mobile && isInColumns()">
            <v-col :cols="getNumberOfCols()" v-for="option in field.datos" :key="option.valor">
                <v-radio
                    color="main_color"
                    :label="option.etiqueta"
                    :value="option.valor"
                    :readonly="readonly"
                ></v-radio>
                <v-img
                    v-if="hasImage()"
                    :src="option.file"
                    :key="'img_'+option.valor"
                    max-height="160"
                    class="mb-1" contain position="left">
                </v-img>
            </v-col>
        </v-row>
        <template v-else v-for="option in field.datos" >
            <v-radio
                color="main_color"
                :label="option.etiqueta"
                :value="option.valor"
                :key="option.valor"
                class="pt-2"
                :readonly="readonly"
            />
            <v-img v-if="hasImage()"
                :src="option.file"
                :key="'img_'+option.valor"
                 max-height="170"
                class="mb-1" contain position="left">
            </v-img>
        </template>

        <div v-if="field.ayuda != ''" class="text-body-2 grey--text">{{field.ayuda}}</div>

    </v-radio-group>
</template>

<script>
    import procedureFormValidator from "@/form/procedure.form.validator";

    export default {
        name: "Radio",
        props: ['field', 'label', 'readonly', 'formValues', 'dynamicTable'],
        data(){
            return {
                rules: [procedureFormValidator.input.required(this.field.validacion.required, this.readonly)],
                formValue: null
            }
        },

        mounted() {
            if (this.formValues[this.field.nombre] != null){
                this.formValue = this.dynamicTable ? this.formValues[this.field.nombre].value : this.formValues[this.field.nombre]
            }
        },

        methods:{
            orientation(){
                let isHorizontal = this.field.extra.orientacion && this.field.extra.orientacion == 'horizontal'
                return {
                    row: isHorizontal,
                    column: !isHorizontal
                }
            },

            isInColumns(){
                let orientation = this.field.extra.orientacion
                if (orientation && (orientation == 'horizontal' || orientation == 'vertical')){
                    return false
                }

                return true
            },

            getNumberOfCols(){
                let orientation = this.field.extra.orientacion
                if (orientation == 'dos_columnas'){
                    return 6;
                }
                else if (orientation == 'tres_columnas'){
                    return 4;
                }
                else if (orientation == 'cuatro_columnas'){
                    return 3;
                }

                return 12
            },

            hasImage (){
                return (this.field.extra.imagenItem && this.field.extra.imagenItem == 1)
            },

            onSelectChange(value){
                this.field.datos.forEach(item => {
                    if (item.valor === value){
                        if (this.dynamicTable){
                            this.formValues[this.field.nombre] = {value: item.valor, label: item.etiqueta}
                        }else {
                            this.formValues[this.field.nombre] = value
                        }
                    }
                })

            }
        }
    }
</script>

<style scoped>

</style>